module.exports = __webpack_public_path__ + "images/fa-cm2024-banner-block-laptop.webp";